import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Progress } from "../components/ui/progress";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Textarea } from "../components/ui/textarea";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex, useModelCreate, useModelUpdate, useBaseOwnerId } from "@rhino-project/core/hooks";
import { asSubmission, listResults } from "../lib/thirdDoorAdapters";

export default function SponsorView() {
    const [query, setQuery] = useState("");
    const organizationId = useBaseOwnerId();
    const { resources } = useModelIndex("submission" as any, { search: query, limit: 25 } as any);
    const queue = listResults(resources).map(asSubmission);
    const { mutate: updateSubmission } = useModelUpdate("submission" as any);
    const { mutate: createRoutingRecommendation } = useModelCreate("routing_recommendation" as any);
    const filtered = useMemo(() => queue.filter((item) => item.id.toLowerCase().includes(query.toLowerCase())), [query]);
    const [action, setAction] = useState("advance");
    const [comment, setComment] = useState("Strong fit for cold-weather sensing workstream.");
    const [saved, setSaved] = useState(false);
  return (
   <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Sponsor Triage Queue</h1>
      <Card><CardContent className="flex flex-wrap items-center gap-3 p-4"><Badge>{filtered.length} files</Badge><Input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search queue" className="max-w-xs" /><Button variant="outline" onClick={() => setQuery("")}>Clear</Button></CardContent></Card>
      <Card>
      <CardContent className="overflow-x-auto p-0">
      <Table>
      <TableHeader><TableRow><TableHead>File</TableHead><TableHead>Confidence</TableHead><TableHead>Status</TableHead><TableHead /></TableRow></TableHeader>
      <TableBody>
      {filtered.map((row) => (
      <TableRow key={row.id}><TableCell>{row.id}</TableCell><TableCell><div className="w-32"><Progress value={row.score} /></div></TableCell><TableCell><Badge variant={row.score > 75 ? "secondary" : "outline"}>{row.score > 75 ? "Priority" : "Review"}</Badge></TableCell><TableCell><Button asChild size="sm"><Link to="/sponsor-view/submission-detail">Open</Link></Button></TableCell></TableRow>
      ))}
      </TableBody>
      </Table>
      </CardContent>
      </Card>
      </section>
  <section>
      <Card>
      <CardContent className="space-y-4 p-4">
      <Select value={action} onValueChange={setAction}>
      <SelectTrigger><SelectValue /></SelectTrigger>
      <SelectContent className="bg-popover text-popover-foreground">
      <SelectItem value="advance">Advance to proposal</SelectItem>
      <SelectItem value="request">Request clarification</SelectItem>
      <SelectItem value="decline">Decline</SelectItem>
      </SelectContent>
      </Select>
      <Textarea rows={4} value={comment} onChange={(event) => setComment(event.target.value)} />
      <Button type="button" onClick={() => { const selected = filtered[0]; if (selected?.id) { updateSubmission({ id: selected.id, status: action } as any); createRoutingRecommendation({ submission_id: selected.id, recommended_mechanism: action, rationale: comment, status: action, organization_id: Number.isFinite(organizationId) ? organizationId : undefined } as any); } setSaved(true); }}>Save action</Button>
      {saved && <p className="text-sm text-primary">Routing action captured.</p>}
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}